export const DEFAULT_INTERCOM_VERTICAL_PADDING = 20;

let showIntercomTimer: ReturnType<typeof setTimeout> | null = null;

export function hideIntercomButton() {
  // If there's a pending show timer, clear it so Intercom won't be shown
  if (showIntercomTimer) {
    clearTimeout(showIntercomTimer);
    showIntercomTimer = null;
  }
  // Force-hide Intercom immediately
  window.Intercom?.('update', { hide_default_launcher: true });
}

export function showIntercomButton() {
  // In case there's already a pending timer, clear it first
  if (showIntercomTimer) {
    clearTimeout(showIntercomTimer);
  }
  // Schedule the Intercom to show after 1 second
  showIntercomTimer = setTimeout(() => {
    window.Intercom?.('update', { hide_default_launcher: false });
    showIntercomTimer = null; // reset once it runs
  }, 1000);
}

export function updateIntercom(opts) {
  window.Intercom?.('update', opts);
}

export function toggleIntercomButton(showLauncher: boolean) {
  window.Intercom?.('update', { hide_default_launcher: !showLauncher });
}
